import script from "./ReservationPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReservationPage.vue?vue&type=script&setup=true&lang=ts"

import "./ReservationPage.vue?vue&type=style&index=0&id=c8aafda4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8aafda4"]])

export default __exports__